/**
 * SegmentedButton — grup radio-style cu opțiuni inline, stil codex-v6.
 */
interface Option<T extends string> {
  value: T;
  label: string;
}

interface Props<T extends string> {
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
  size?: 'sm' | 'md';
}

export default function SegmentedButton<T extends string>({
  options,
  value,
  onChange,
  size = 'md',
}: Props<T>) {
  const pad = size === 'sm' ? '4px 10px' : '6px 14px';
  const fontSize = size === 'sm' ? 11 : 12;
  return (
    <div
      className="inline-flex rounded-md p-0.5"
      style={{
        background: 'var(--bg-surface)',
        border: '1px solid var(--border)',
      }}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className="rounded transition-colors font-medium"
            style={{
              padding: pad,
              fontSize,
              color: active ? 'var(--bg-elevated)' : 'var(--text-muted)',
              background: active ? 'var(--accent)' : 'transparent',
              boxShadow: active ? 'var(--glow-mint)' : 'none',
            }}
            onMouseEnter={(e) => {
              if (!active) e.currentTarget.style.color = 'var(--text)';
            }}
            onMouseLeave={(e) => {
              if (!active) e.currentTarget.style.color = 'var(--text-muted)';
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
